import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { Colors } from '../../../util/util'

const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

export const styles = {
  maincontainer: {
    padding: 16,
    flex: 1,
    overflow: 'scroll',
    backgroundColor: 'BACKGROUND',
  } as BoxProps,
  container: {
    ...shadowStyle,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: 'WHITE',
    borderColor: 'GRAY_BORDER',
  } as BoxProps,

  formContainer: {
    zIndex: 5,
    w: '100%',
  } as BoxProps,

  heading: {
    fontSize: 20,
    fontWeight: '700',
    color: 'BLACK_21',
    fontFamily: 'JioType-Black',
  } as TextProps,
  title: {
    fontSize: 16,
    lineHeight: 20,
    color: 'BLACK_21',
    fontFamily: 'JioType-Black',
  } as TextProps,
  wraperItemStyle: {
    minWidth: 482,
    p: 24,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'DISABLED_GREY',
    flexDirection: 'row',
    backgroundColor: 'rgba(0, 112, 182, 0.04)' as ColorOptions,
  } as BoxProps,
  btn: {
    bg: 'BLUE',
    underlayColor: 'PRIMARY',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    shadowRadius: 2,
  },
  textList: {
    fontFamily: 'JioType-Medium',
    fontSize: 12,
    lineHeight: 16,
    color: 'BLACK_21',
  } as TextProps,
  circleIcon: {
    width: 48,
    height: 48,
    borderRadius: 48 / 2,
    bg: Colors.SPLASH as ColorOptions,
    align: 'center',
    justify: 'center',
  } as BoxProps,
}
